/**
 * @module app.shared
 */

const DEFAULT_BINDINGS = ['bind'];

// INFO [Matt] This RegExp is for attempting to find a property name out of a template.
const INTERPOLATION_RE = /^\s*\${((?:[A-Za-z0-9]+)(?:\.[A-Za-z0-9]+)*)(?:\s*\|\s*[a-zA-Z0-9:]*)*}\s*$/;

/**
 * Build a string interpolation based on the given `expression`
 * @param expression the JavaScript or Aurelia Binding expression
 * @returns the expression wrapped in `${expression}`
 */
export function buildInterpolation(expression: string): string {
    if(!expression) { return ''; }
    return `\$\{${expression}}`;
}

/**
 * Parses the given attribute (and bindable version of the attribute) and returns the binding expression.
 *
 * If the attribute is constant, it returns a JavaScript string representing that constant value.
 *
 * For example `getAttributeBinding(element, 'header')` will search for:
 *  - `header="${binding}"`
 *  - `header="constant"`
 *  - `header.bind="binding"`
 *
 * @param element the element to search
 * @param attribute the attribute to search
 * @param bindings additoinal bindable attribute suffixes to search, default `['bind']`
 * @returns the binding expression, if it exsits
 */
export function getAttributeBinding(element: Element, attribute: string, bindings: string[] = DEFAULT_BINDINGS): string | null {
    const value = element.getAttribute(attribute);
    if(value) { return value; }
    // attribute.bind=
    for(const binding of bindings) {
        const value = element.getAttribute(`${attribute}.${binding}`);
        if(value) {
            // attribute.bind="foo" => foo
            return buildInterpolation(value);
        }
    }

    return null;
}
